import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {saveAs} from 'file-saver';
import {ToastsService} from "../toasts.service";

@Injectable({
  providedIn: 'root'
})
export class ParcelsService {
  private apiurl = '';

  constructor(private http: HttpClient, private router: Router, private toastsService: ToastsService) {
    this.apiurl = environment.api;
  }

  getStatusTypes(id=0) {
    const url = this.apiurl + 'statuses/select/' + id;
    return this.http.get(url);
  }

  listWorkstationTypeAvailableStatusTypes(workstationTypeId) {
    return this.http.get(
      this.apiurl + 'app/v1/status_type/sorted_for_warehouse_select/' + workstationTypeId,
    );
  }

  findStatusTypesForWarehouseSelect() {
    return this.http.get(
      this.apiurl + 'app/v1/status_type/sorted_for_warehouse_select/0'
    );
  }

  getParcelStatuses(internal) {
    const url = this.apiurl + 'parcel/' + internal;
    return this.http.get(url);
  }

  getPublicParcelStatusHistory(internal) {
    const url = this.apiurl + 'tracking/' + internal;
    return this.http.get(url, {observe: 'response'});
  }

  getPublicParcelOutNumber(out) {
    const url = this.apiurl + 'tracking/external/' + out;
    return this.http.get(url);
  }


  setStatus(form) {
    const url = this.apiurl + 'parcel/status';
    return this.http.put(url, form);
  }

  setGroupStatus(form) {
    const url = this.apiurl + 'parcel/status/group';
    return this.http.put(url, form);
  }

  deleteStatus(id) {
    const url = this.apiurl + 'parcel/status';
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        id,
      },
    };
    return this.http.delete(url, options);
  }

  getPublicFileToken(){
    const url = this.apiurl + 'public_token';
    return this.http.get(url);
  }
}
